export const SET_INTRO_PRICE_PAYWALL_VIEWED = 'SET_INTRO_PRICE_PAYWALL_VIEWED';
export const SET_INTRO_PRICE_PAYWALL_VIEWED_SUCCESS = 'SET_INTRO_PRICE_PAYWALL_VIEWED_SUCCESS';
export const SET_INTRO_PRICE_PAYWALL_VIEWED_ERROR = 'SET_INTRO_PRICE_PAYWALL_VIEWED_ERROR';
export const SET_INTRO_PRICE_NOTIFICATION_SHOWN = 'SET_INTRO_PRICE_NOTIFICATION_SHOWN';
